import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { AddIcon, ArrowIcon, DeleteIcon, DownloadIcon, EditIcon, FilterIcon, HideIcon, PrintIcon, RestoreIcon, ShowIcon, WalletIcon } from '../images/icons';
import { SubmitButton } from '../forms/FormItems';
import { DatePreset } from './FormElements';
import { confirmState, errorState, feedbackModel, uistate } from '../stores/common';
import { formatDate } from '../functions';
import { InlineError } from './FeedbackComponents';

/** Заголовок страницы создания и редактирования элемента */
export class ItemNewHeader extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	/** Закрытие карточки по Escape, если поверх неё не открыто другое окно */
	onKeyDown = (event) => {
		const hasError = !_.isNull(errorState.ErrorText) && errorState.ErrorText !== "",
			hasFormModal = !_.isNull(document.querySelector(".formModal"));

		if (event.key === "Escape" && !feedbackModel.ModalOpen && !confirmState.ConfirmOpen
			&& !hasError && !hasFormModal) {
			this.props.handleClose(event);
		}
	}

	render() {
		var style = { left : uistate.IsTablet ? 50 : uistate.IsSideBarOpen ? 260 : 50 };

		return(
			<div className={"head itemNewHead " + (uistate.IsMobile ? "mobile" : "")} style={style}>
				{(_.isUndefined(this.props.HideClose) || this.props.HideClose === false) &&
					<button type="button" className="backList iconSVG" title="Назад"
						onClick={this.props.handleClose}><ArrowIcon /></button>
				}
				<h2>{this.props.Title}</h2>
				<InlineError ErrorCode={this.props.ErrorCode} Success={this.props.SuccessSave} />
				{this.props.CanManage &&
					<SubmitButton Title="Сохранить" Action="save" Loading={this.props.ButtonLoading} />
				}
				{this.props.CanAccept &&
					<SubmitButton Title={this.props.AcceptTitle || "Сохранить и подтвердить"}
						Action="accept" ClassName="green" Loading={this.props.ButtonLoading} />
				}
			</div>
		)
	}
}
ItemNewHeader = observer(ItemNewHeader);

/** Кнопка создания нового элемента страницы */
export class CreateButton extends Component {
	render() {
		return(
			<button type="button" className="create blue" onClick={this.props.onClick}>
				{uistate.IsMobile ? "Создать" : (this.props.Title || "Создать")}
			</button>
		)
	}
}

/** Обычная кнопка добавления элемента */
export class AddButton extends Component {
	render() {
		const withIcon = this.props.Icon !== false;

		return(
			<button type="button" className={"button secondary addButton" + (withIcon ? " iconSvg" : "")}
				onClick={this.props.onClick}>
				{withIcon && <AddIcon />} {this.props.Title || "Добавить"}
			</button>
		)
	}
}

/** Основная кнопка оплаты */
export const PayButton = ({ Deadline, Expired = false, Disabled = false, onClick }) => {
	const title = Deadline ? "Оплатить до " + formatDate(Deadline, "DD.MM") 
		: Expired ? "Срочно оплатить" : "Оплатить";
	return(
		<button
			type="button"
			className={"button iconSvg pay " + (Expired ? "red" : "green")}
			disabled={Disabled}
			onClick={onClick}
		>
			<WalletIcon /> {title}
		</button>
	)
};

/** Иконочная кнопка добавления элемента */
export class AddIconButton extends Component {
	render() {
		return(
			<button type="button" className="iconSvg add" title="Добавить" onClick={this.props.onClick}>
				<AddIcon />
			</button>
		)
	}
}

/** Кнопка раскрытия и сворачивания блока страницы */
export class ExpandIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className={'iconSvg expandIconButton' + (this.props.IsOpen ? " active" : "")}
				title={this.props.IsOpen ? "Свернуть" : "Развернуть"}
				onClick={this.props.onClick}
			>
				<ArrowIcon />
			</button>
		)
	}
}

/** Иконочная кнопка открытия и закрытия фильтра */
export class FilterIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className={'iconSvg filter' + (this.props.IsOpen ? " active" : "")}
				title="Фильтр поиска"
				onClick={this.props.onClick}
			>
				<FilterIcon />
			</button>
		)
	}
}

/** Общая форма основного фильтра страницы */
export class MainFilterBlock extends Component {
	/** Проверка фильтра и отправка запроса в выбранном формате */
	submit = (outForm) => {
		if (!_.isUndefined(this.props.Filter.OutForm))
			this.props.Filter.collect("OutForm", outForm);
		if (this.props.Filter.validate && !this.props.Filter.validate()) return;

		this.props.onSubmit();
	}

	/** Отправка формы для отображения результата на странице */
	handleSubmit = (event) => {
		event.preventDefault();
		this.submit("json");
	}

	render() {
		const {
			Filter, IsOpen, IsPartialOpen = true, CanDownload = false,
			MaxDate, Preset, children
		} = this.props;

		if (!IsPartialOpen && !IsOpen) return null;

		const hasDatePreset = !_.isUndefined(Filter.DateFrom) && !_.isUndefined(Filter.DateTo);

		return(
			<form className="filterBlock" onSubmit={this.handleSubmit}>
				<div>
					{hasDatePreset &&
						<DatePreset
							DateFrom={Filter.DateFrom}
							DateTo={Filter.DateTo}
							Preset={Preset}
							MaxDate={MaxDate || null}
							IsClearable={false}
							onChange={(value, id) => Filter.collect(id, value)}
						/>
					}
					{(!IsPartialOpen || IsOpen) &&
						<div className="lists">{children}</div>
					}
				</div>
				<div className="buttons">
					<SubmitButton Title="Найти" />
					{CanDownload && (!IsPartialOpen || IsOpen) &&
						<button type="button" className="button secondary iconSvg" onClick={() => this.submit("file")}>
							<DownloadIcon /> Скачать
						</button>
					}
				</div>
			</form>
		)
	}
}
MainFilterBlock = observer(MainFilterBlock);

/** Иконочная кнопка удаления элемента */
export class RemoveIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg remove"
				title="Удалить"
				onClick={this.props.onClick}
			>
				<DeleteIcon />
			</button>
		)
	}
}

/** Иконочная кнопка восстановления элемента */
export class RestoreIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg restore"
				title="Восстановить"
				onClick={this.props.onClick}
			>
				<RestoreIcon />
			</button>
		)
	}
}

/** Иконочная кнопка обработки элемента */
export class ProcessIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg process"
				title={this.props.Title || "Обработать"}
				onClick={this.props.onClick}
			>
				<RestoreIcon />
			</button>
		)
	}
}

/** Иконочная кнопка редактирования элемента */
export class EditIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg edit"
				title={this.props.Title || "Редактировать"}
				onClick={this.props.onClick}
			>
				<EditIcon />
			</button>
		)
	}
}

/** Иконочная кнопка скачивания файла */
export class DownLoadIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg download"
				title={this.props.Title || "Скачать PDF"}
				onClick={this.props.onClick}
			>
				<DownloadIcon />
			</button>
		)
	}
}

/** Иконочная кнопка печати */
export class PrintIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className="iconSvg print"
				title={this.props.Title || "Распечатать"}
				onClick={this.props.onClick}
			>
				<PrintIcon />
			</button>
		)
	}
}

/** Иконочная кнопка изменения видимости элемента */
export class VisibilityIconButton extends Component {
	render() {
		return(
			<button
				type="button"
				className={"iconSvg " + (this.props.Active ? "remove" : "")}
				title={this.props.Active ? "Скрыть" : "Показать"}
				onClick={this.props.onClick}
			>
				{this.props.Active ? <HideIcon /> : <ShowIcon />}
			</button>
		)
	}
}
